import {useState} from 'react';

type VirtualQWidgetApi = {
  toggleWidget: () => void;
};

export const useVirtualQ = (): {
  isLoading: boolean;
  loadWidget: (widgetUrl: string) => Promise<VirtualQWidgetApi | null>;
} => {
  const [isLoading, setIsLoading] = useState(false);

  return {
    isLoading: isLoading,
    loadWidget: async (widgetUrl: string) => {
      try {
        setIsLoading(true);
        const api = await import(/* @vite-ignore */ widgetUrl);
        if (api && typeof api.toggleWidget === 'function') {
          return api as VirtualQWidgetApi;
        }
        return null;
      } catch {
        return null;
      } finally {
        setIsLoading(false);
      }
    },
  };
};
